import React from 'react';
import {HStack, VStack, Avatar} from '@chakra-ui/react';
import {TextG12, TextG14} from '../../../components/typography';
import {getDisplayName} from '../../../utils/nameFormatters';

interface ConnectionCardProps {
  connection: {
    id: number;
    name: string;
    surname?: string;
    handle?: string;
    profile_photo_url?: string;
    is_following?: boolean;
    is_followed_by?: boolean;
    is_friend?: boolean;
  };
  onPress?: () => void;
}

const ConnectionCard = ({connection, onPress}: ConnectionCardProps) => {

  return (
    <HStack
      as="button"
      w="100%"
      p={4}
      spacing={3}
      bg="white"
      borderBottom="1px solid #F0F0F0"
      onClick={onPress}
      _active={{bg: '#FAFAFA'}}
      textAlign="left">
      <Avatar
        name={connection.name}
        src={connection.profile_photo_url || undefined}
        size="md"
      />
      <VStack align="flex-start" spacing={0} flex={1}>
        <TextG14 mt="0" fontWeight="600">
          {getDisplayName(connection)}
        </TextG14>
        {connection.handle && (
          <TextG12 mt="0" color="#757D84">
            @{connection.handle}
          </TextG12>
        )}
      </VStack>
      <i
        className="fi fi-rr-angle-small-right"
        style={{fontSize: '16px', color: '#757D84'}}
      />
    </HStack>
  );
};

export default ConnectionCard;
